export default __webpack_public_path__ + "static/lsa-mobile-screens-mobile-7b3c16f8304bf56e0ee64717cb3d1db1.jpg";